module.exports = __webpack_public_path__ + "img/luz-e-sombra.fb511c5d.jpg";